import type { EditorState } from "@tiptap/pm/state";

import { findActiveResourceQuery } from "../../domain/formula-grammar";

import type { SuggestionState } from "./suggestion-types";

interface GetSuggestionStateOptions {
  containerRect?: DOMRect | null;
  getCoordsAtPos: (pos: number) => { top: number; bottom: number; left: number };
}

/**
 * Extracts suggestion metadata when typing `{query}`.
 */
export function getSuggestionState(
	state: EditorState,
	options: GetSuggestionStateOptions
): SuggestionState | null {
	const { containerRect, getCoordsAtPos } = options;

	const { from, $from } = state.selection;
	const blockStart = $from.start($from.depth);
	const textBefore = state.doc.textBetween(blockStart, from, "\n", "\n");
	const hit = findActiveResourceQuery(textBefore);

	if (!hit || hit.query.includes("\n")) {
		return null;
	}

	let coords;
	try {
		coords = getCoordsAtPos(from);
	} catch {
		return null;
	}

	const position = {
		top: coords.bottom - (containerRect?.top ?? 0) + 8,
		left: coords.left - (containerRect?.left ?? 0),
	};

	return {
		active: true,
		query: hit.query,
		range: { from: blockStart + hit.openIndex, to: from },
		position,
	};
}
